import { gql } from 'apollo-boost';

export const create = gql`
  mutation create($glCode: GlCodeCreateInput!) {
    orgRef_GlCode {
      create(glCode: $glCode) {
        id
        externalId
        name
        description
        active
        rowVersion
      }
    }
  }
`;

export const update = gql`
  mutation update($glCode: GlCodeUpdateInput!) {
    orgRef_GlCode {
      update(glCode: $glCode) {
        id
        externalId
        name
        description
        active
        rowVersion
      }
    }
  }
`;

export const deleteItems = gql`
  mutation delete($glCodeId: Int!) {
    orgRef_GlCode {
      delete(glCodeId: $glCodeId)
    }
  }
`;
